/**
 * api 模块
 * @description production块内是线上接口
 *              else 块内是mock接口
 */

let api

if (process.env.NODE_ENV === 'production') {
    api = {
      // 所有问题及类目
      digg: '/c27/online_courseware/help_center/questions/',
      get_question: '/c27/online_courseware/help_center/questions/',
      search_questions: '/c27/online_courseware/help_center/landing_page/category/question/search/',
      get_landing_page_info:'/c27/online_courseware/help_center/platform/landing_page/',
      get_category_list:'/c27/online_courseware/help_center/landing_page/category/question/',
    }
} else {
    api = {
      // 所有问题及类目
      digg: '/c27/online_courseware/help_center/questions/',
      get_question: '/c27/online_courseware/help_center/questions/',
      search_questions: '/c27/online_courseware/help_center/landing_page/category/question/search/',
      get_landing_page_info:'/c27/online_courseware/help_center/platform/landing_page/',
      get_category_list:'/c27/online_courseware/help_center/landing_page/category/question/'
    }
}


export { api }



// WEBPACK FOOTER //
// ./src/html/help/config.js